import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from "vue-sweetalert2";

import Gmixins from "@/mixins/Gmixins";

import Socketio from "@/plugins/SocketIO";
import Toaster from "@meforma/vue-toaster";
import Fetch from "@/plugins/Fetch";

import AppTitle from "@/components/app/title";
import AppButton from "@/components/app/appButton";

import AppLoader from "@/components/app/loader";
import AppError from "@/components/app/error";
import AppMenu from "@/components/app/menu";


createApp(App)
    .use(Socketio, {
        connection: window.location.origin,
        options: {
            withCredentials: true,
            Headers: {
                'Access-Control-Allow-Origin': true
            },
        },
    })
    .use(Toaster, {
        position: 'top-right',
        duration: 2000,
        progressBar: true,
    })
    .use(Fetch)
    .use(VueSweetalert2, {
        showCloseButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Закрыть",
    })
    .use(store)
    .use(router)
    .mixin(Gmixins)
    .component("AppTitle", AppTitle)
    .component("AppLoader", AppLoader)
    .component("AppError", AppError)
    .component("AppButton", AppButton)
    .component("AppMenu", AppMenu)
.mount('#app')
